module.exports = __webpack_public_path__ + "static/media/empty-guy.73658f1a.svg";